import { useAppSelector } from "@/redux/hooks";
import { useCheckoutUI } from "../CheckoutUIProvider";

export const useCheckoutRetailer = () => {
  const retailers = useAppSelector((state) => state.retailers);
  const [state] = useCheckoutUI();
  const retailerId = state.context.checkoutIntent?.retailerId;
  const currentRetailer = retailers.find(
    (retailer) => retailer.retailerId === retailerId
  );

  return {
    currentRetailer,
  };
};
